import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tooltip, Typography, withStyles, Grid, Collapse, Button } from '@material-ui/core';
import { CompareArrows as CompareArrowsIcon, Message as MessageIcon } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux'
import { faChevronDown, faChevronUp, faAngleUp, faAngleDown, faSyncAlt, faCalendarCheck } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle, faThumbsUp } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import { Card, CardContent } from '@material-ui/core';
import MaterialTable, { MTableToolbar, MTableBody } from 'material-table';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import ReactSelect from "../../../../common/components/UI/Select/ReactSelect";
import moment from 'moment';
import { AdditionalInfo } from '../../../../common-client2/src/components';
import { getAsLongDate, getAsStartAndEndTimeFormat, getAsLongDateTime, formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { hasTransfer } from '../../../auxilaries'
import EmployeeCalendar from '../EmployeeCalendar';
import { ManagerTableViewStyles } from '../../../styles/styles';
import TooltipDataviewEmployee from '../../../../common/components/UI/ToolTip/TooltipDataviewEmployee';
import _ from 'lodash';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { ShiftCardWithTooltip } from '../ShiftCardWithTooltip';
import {
    RequestTypes, RequestSubtypes, ShiftSegmentTypeName, RequestStatus,
} from '../../../Enums'
import { tableIcons } from '../constants'
import { updateFetchSizeOption } from '../actions'
import ManagerWarningContent from '../ManagerWarningContent';
import SubmissionPeriodLabel from './SubmissionPeriodLabel';
import RequestTypeChip from '../RequestTypeChip';
import { MomentFormats } from '../../../utils';
import { GetModifiedBy } from '../helpers/ManageRequests.helper';
import './dataviewTable.scss';

const WarnTooltip = withStyles({
    tooltip: {
        backgroundColor: 'white',
        color: '#3A3A3A',
        maxWidth: "520px",
        border: '1px solid #dadde9',
    },
})(Tooltip);

const displayDurationInHours = (segment) => `[${(new Date(segment.endDateTime) - new Date(segment.startDateTime)) / 1000 / 60 / 60}]`;


class DataviewTable extends React.Component {
    constructor(props) {
        super(props);
        this.theme = createTheme({
            palette: {
                primary: {
                    main: '#66b3ff',
                },
                secondary: {
                    main: '#66b3ff',
                },
            },

        });
        this.state = {
            opened: false
        }
    }

    handleSelectFetchSize = (target, value) => {
        this.props.updateFetchSizeOption(value);
    }

    generateShiftColors = (status, actionType, isEeTo) => {
        let color = {}
        switch (status) {
            case 'Refused':
            case 'Submitted':
            case 'Pending':
            case 'Retracted':
                color.bgColor = '#FFF'
                color.color = '#333'
                color.borderColor = '#0A54A2'
                switch (actionType) {
                    case RequestTypes.toCover:
                        color.borderColor = isEeTo ? '#ffdd00' : '#0A54A2'
                        break;
                    case RequestTypes.shiftSwap:
                        color.borderColor = isEeTo ? '#FF7A59' : '#0A54A2'
                        break;
                    case RequestTypes.openShift:
                        color.borderColor = '#EE0F0F'
                        break;
                    case RequestTypes.voluntaryTimeOff:
                        color.borderColor = '#006600'
                        break;
                    default:
                        break;
                }
                break;
            case 'Approved':
                color.bgColor = '#FFF'
                color.borderColor = '#0A54A2'
                color.color = '#7a7a7a'
                if (actionType === RequestTypes.voluntaryTimeOff) {
                    color.borderColor = '#006600'
                }
                break;
            default:
                color = {
                    color: '#48D960',
                    bgColor: 'transparent',
                    borderColor: '#0A54A2',
                }
        }
        return color
    }

    getChipClass = (rowData, classes) => {
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                return classes.chipTC;
            case RequestTypes.shiftSwap:
                return classes.chipSS;
            case RequestTypes.openShift:
                return classes.chipOS;
            case RequestTypes.voluntaryTimeOff:
                return classes.chipVTO;
            default:
                break;
        }

        return classes.chipFormatting;
    }


    generateSchedule = (rowData, type) => {
        const generateScheduleTitle = (shift, transferSegment) => `${(shift.label ? `${shift.label} ` : '')}${getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}${(transferSegment ? ' (x)' : '')}`;

        let shiftOffer, shiftOffers, paycodes;
        let schedule = [];
        let status;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                status = rowData.status.value;
                shiftOffer = rowData.shift;
                if (rowData.isPartial) {
                    shiftOffer = rowData.partialShift;
                }
                break;
            case RequestTypes.shiftSwap:
                status = rowData.status.value;
                shiftOffer = rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails;

                if (rowData.isPartialOffer) {
                    shiftOffer = rowData.partialOfferShift;
                }
                break;
            case RequestTypes.openShift:
                status = rowData.status.value;
                shiftOffer = rowData.shift;
                if (rowData.isPartial) {
                    shiftOffer = rowData.partialShift;
                }
                break;
            case RequestTypes.voluntaryTimeOff:
                status = rowData.status.label;
                shiftOffers = rowData.shifts.map(x => x.shiftInfo.shiftDetails)
                shiftOffer = { id: -1, label: "Not used" }
                paycodes = rowData.paycodes || []
                // Set startDateTime and endDateTime for each paycode
                paycodes.forEach(pc => {
                    pc.startDateTime = pc.startDate
                    pc.endDateTime = pc.endDate
                })
                break;
            default:
                break;
        }

        let color = this.generateShiftColors(status, rowData.actionType, type === 'to')

        switch (status) {
            case 'Approved':
                if (type === 'from') {
                    // First employee schedule generation
                    let employeeFromShifts = rowData.employeeFromSchedule
                    for (let shift of employeeFromShifts) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift://should not reach here
                                schedule.push({
                                    id: shift.id,
                                    calendarId: '0',
                                    title: generateScheduleTitle(shift, transferSegment),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: shiftStartDateTimeInISO,
                                    end: shiftStartDateTimeInISO,
                                    customStyle: 'padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: {
                                        ...shift,
                                        status: rowData.status.value
                                    },
                                })
                                break;
                            default:
                                break;
                        }

                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            const transferSegment = shiftOffer.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                            const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, transferSegment),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 1px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shiftOffer,
                                    status: rowData.status.value
                                },
                                color: color.color,
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        default:
                            break;
                    }
                }
                else {
                    // Second employee schedule generation
                    let employeeToShifts = rowData.employeeToSchedule
                    for (let shift of employeeToShifts) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                schedule.push({
                                    id: shift.id,
                                    calendarId: '0',
                                    title: generateScheduleTitle(shift, transferSegment),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: shiftStartDateTimeInISO,
                                    end: shiftStartDateTimeInISO,
                                    customStyle: 'padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: {
                                        ...shift,
                                        status: rowData.status.value
                                    }
                                })
                                break;
                            default:
                                break;
                        }
                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shiftOffer,
                                    status: rowData.status.value
                                },
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        case RequestTypes.voluntaryTimeOff:
                            for (const paycode of paycodes) {
                                if (!!paycode?.payCodeRef) {
                                    schedule.push({
                                        id: paycode.id,
                                        calendarId: '2',
                                        title: paycode.payCodeRef.qualifier,
                                        category: 'time',
                                        dueDateClass: '',
                                        start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                        end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                        customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                        isReadOnly: true,
                                        raw: paycode,
                                        color: '#7a7a7a',
                                        bgColor: color.bgColor,
                                        borderColor: color.borderColor
                                    })
                                }
                            }
                            for (const offer of shiftOffers) {
                                const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                                schedule.push({
                                    id: offer.id,
                                    calendarId: '1',
                                    title: generateScheduleTitle(offer, false),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: offerStartDateTimeInISO,
                                    end: offerStartDateTimeInISO,
                                    customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: {
                                        ...offer,
                                        status: rowData.status.value
                                    },
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            break;
                        default:
                            break;
                    }
                }
                break;
            case 'Refused':
            case 'Submitted':
            case 'Pending':
            case 'Retracted':
            default:
                if (type === 'from') {
                    // First employee schedule generation
                    let employeeFromShifts = rowData.employeeFromSchedule
                    for (let shift of employeeFromShifts) {
                        if (shift.id !== shiftOffer.id) {
                            const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                            const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: shift.id,
                                calendarId: '0',
                                title: generateScheduleTitle(shift, transferSegment),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftStartDateTimeInISO,
                                end: shiftStartDateTimeInISO,
                                customStyle: 'border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: shift
                            })
                        }
                    }
                    const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                    schedule.push({
                        id: shiftOffer.id,
                        calendarId: '1',
                        title: generateScheduleTitle(shiftOffer, false),
                        category: 'time',
                        dueDateClass: '',
                        start: shiftOfferStartDateTimeInISO,
                        end: shiftOfferStartDateTimeInISO,
                        customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                        isReadOnly: true,
                        raw: shiftOffer,
                        bgColor: color.bgColor,
                        borderColor: color.borderColor
                    })
                }
                else {
                    // Second employee schedule generation
                    let employeeToShifts = rowData.employeeToSchedule
                    for (let shift of employeeToShifts) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shift.id,
                            calendarId: '0',
                            title: generateScheduleTitle(shift, transferSegment),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftStartDateTimeInISO,
                            end: shiftStartDateTimeInISO,
                            customStyle: 'padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shift
                        })
                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: shiftOffer,
                                color: '#7a7a7a',
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        case RequestTypes.voluntaryTimeOff:
                            for (const paycode of paycodes) {
                                if (!!paycode?.payCodeRef) {
                                    schedule.push({
                                        id: paycode.id,
                                        calendarId: '2',
                                        title: paycode.payCodeRef.qualifier,
                                        category: 'time',
                                        dueDateClass: '',
                                        start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                        end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                        customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                        isReadOnly: true,
                                        raw: paycode,
                                        color: '#7a7a7a',
                                        bgColor: color.bgColor,
                                        borderColor: color.borderColor
                                    })
                                }
                            }
                            for (const offer of shiftOffers) {
                                const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                                schedule.push({
                                    id: offer.id,
                                    calendarId: '0',
                                    title: generateScheduleTitle(offer, false),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: offerStartDateTimeInISO,
                                    end: offerStartDateTimeInISO,
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: offer,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            break;
                        default:
                            break;
                    }
                }
                break;
        }
        return schedule;
    }

    generateColumns = (managerSetting, requestColumns, employee1Columns, employee2Columns, dataviewsData, classes) => {
        let columns = [];
        for (let x of requestColumns) {
            if (x.Active) {
                if (x.Dataview) {
                    //                 columns.push(this.generateDataviewColumn(x)); Non existant?
                } else {
                    columns.push(this.generateDefaultRequestColumn(x, classes));
                }
            }
        }

        switch (managerSetting.type) {
            case RequestTypes.toCover:
            case RequestTypes.shiftSwap:
                for (let x of employee1Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            columns.push(this.generateDataviewColumn(x, 1, dataviewsData, classes));
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 1));
                        }
                    }
                }

                for (let x of employee2Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            columns.push(this.generateDataviewColumn(x, 2, dataviewsData, classes));
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 2));
                        }
                    }
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                for (let x of employee1Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            columns.push(this.generateDataviewColumn(x, 1, dataviewsData, classes));
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 1));
                        }
                    }
                }
                break;
            default:
                break;
        }


        return columns.filter(x => x != null);
    }

    getEmployee(rowData, empFromTo) {
        let employee;

        switch (rowData.actionType) {
            case RequestTypes.toCover:
                switch (empFromTo) {
                    case 1:
                        employee = rowData.employeeFrom.id;
                        break;
                    case 2:
                        employee = rowData.employeeTo.id;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        employee = rowData.offerorEmployeeId;
                        break;
                    case 2:
                        employee = rowData.swapProposal.proposalEmployeeId;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                employee = rowData.employeeTo.id;
                break;
            default:
                break;
        }
        return employee;
    }

    getDataviewData(rowData, dataviewsData, dataviewKey, empFromTo) {
        const employee = this.getEmployee(rowData, empFromTo);

        if (employee) {
            const employeeData = dataviewsData[employee];
            if (employeeData) {
                var key = rowData.startDate ? formatAs(rowData.startDate, DateFnsFormats.YMD) : 'ANY';
                let d = dataviewsData[employee][key];
                if (!d) {
                    d = dataviewsData[employee]['ANY'];
                }
                if (d) {
                    let wantedData = d.attributes.find(x => x.key === dataviewKey);
                    if (wantedData) {
                        return wantedData.value;
                    }
                }
            }
        }
        return "";
    }

    generateDataviewColumn(row, empFromTo, dataviewsData) {
        return {
            title: row.Label,
            render: rowData => {
                return <React.Fragment>
                    {this.getDataviewData(rowData, dataviewsData, row.DataviewKey, empFromTo)}
                </React.Fragment>;
            },
            customSort: (a, b) => {
                let valueA = this.getDataviewData(a, dataviewsData, row.DataviewKey, empFromTo)
                let valueB = this.getDataviewData(b, dataviewsData, row.DataviewKey, empFromTo)
                return valueA < valueB ? -1 : 1
            }
        };
    }

    getEmployeeName(rowData, empFromTo) {
        let name;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                switch (empFromTo) {
                    case 1:
                        name = rowData.employeeFrom.name;
                        break;
                    case 2:
                        name = rowData.employeeTo.name;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        name = rowData.offerorEmployeeName;
                        break;
                    case 2:
                        name = rowData.swapProposal.proposalEmployeeName;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                name = rowData.employeeTo.name;
                break;
            default:
                break;
        }
        return name;
    }

    getRelevantDate = (rowData, empFromTo) => {
        let date;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
            case RequestTypes.openShift:
                date = rowData.shift.startDateTime;
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        date = rowData.swapRequestShiftInfo[0].shiftInfo.startDateLocationTime;
                        break;
                    case 2:
                        date = rowData.swapProposalShiftInfo[0].shiftInfo.startDateLocationTime;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                date = rowData.startDate;
                break;
            default:
                break;
        }
        return formatAs(date, DateFnsFormats.YMD);
    }

    getEmployeeShift(rowData, empFromTo, classes) {
        let shiftCard;

        switch (rowData.actionType) {
            case RequestTypes.toCover:
                // EE1 only!
                shiftCard = (<ShiftCardWithTooltip
                    shift={rowData.shift}
                    partialShift={rowData.isPartial ? rowData.partialShift : null}
                    actionType={rowData.actionType}
                    isLargeShiftTimeText
                    timeOffRequest={rowData.timeOffRequest}
                />);
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        return (
                            rowData.swapRequestShiftInfo.length <= 1
                                ?
                                <ShiftCardWithTooltip
                                    shift={rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails}
                                    partialShift={rowData.partialOfferShift ? rowData.partialOfferShift : null}
                                    actionType={rowData.actionType}
                                    isLargeShiftTimeText
                                />
                                :
                                <Button className={classes.transparentButtonNoPadding}>
                                    <Card className={classes.SSShiftCard}>
                                        <CardContent className={classes.fixPadding}>
                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                {rowData.swapRequestShiftInfo.length + "  Shifts"}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Button>
                        )
                    case 2:
                        return (
                            rowData.swapRequestShiftInfo.length <= 1//TODO : supposed to be swapProposalShiftInfo?
                                ?
                                <ShiftCardWithTooltip
                                    shift={rowData.swapProposalShiftInfo[0].shiftInfo.shiftDetails}
                                    partialShift={rowData.isPartialProposal ? rowData.partialProposalShift : null}
                                    actionType={rowData.actionType}
                                    isLargeShiftTimeText
                                />
                                :
                                <Button className={classes.transparentButtonNoPadding}>
                                    <Card className={classes.SSShiftCard}>
                                        <CardContent className={classes.fixPadding}>
                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                {rowData.swapProposalShiftInfo.length + "  Shifts"}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Button>
                        )
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
                shiftCard = (
                    <ShiftCardWithTooltip
                        shift={rowData.shift}
                        partialShift={rowData.isPartial ? rowData.partialShift : null}
                        actionType={rowData.actionType}
                        isLargeShiftTimeText
                        isApproved={rowData.status.label === 'Approved'}
                    />
                )
                break;
            case RequestTypes.voluntaryTimeOff: {
                let shifts = [];
                if (rowData.voluntaryTimeOffType === 2) {
                    shifts = rowData.status.value !== RequestStatus.RetractedSubmitted ? rowData.previousShiftsHistory : (!!rowData.shifts ? rowData.shifts.map(x => x.shiftInfo.shiftDetails) : []);
                } else {
                    shifts = rowData.shifts?.map(x => x?.shiftInfo?.shiftDetails) ?? [];
                }

                return (
                    (!!shifts && shifts.length === 1)
                        ?
                        <ShiftCardWithTooltip
                            shift={shifts[0]}
                            partialShift={rowData.partialShift}
                            actionType={rowData.actionType}
                            isLargeShiftTimeText
                            isApproved={rowData.status.label === 'Approved'}
                            isVto={true}
                        />
                        :
                        <Button className={classes.transparentButtonNoPadding}>
                            <Card className={rowData.status.label === 'Approved' ? classes.VTOShiftCard : classes.VTOShiftCardApproved}>
                                <CardContent className={classes.fixPadding}>
                                    <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                        {(shifts?.length ?? 0) + "  Shifts"}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Button>
                )
            }
            default:
                return null
        }
        return shiftCard;
    }

    generateDefaultEmployeeColumn(row, classes, empFromTo) {
        const { employee1Columns, employee2Columns, dataviewsData, managerSetting } = this.props
        let columns = empFromTo === 1 ? employee1Columns : employee2Columns

        switch (row.DataviewKey) {
            case "DEFAULT__EMPLOYEE_NAME":
                return {
                    title: empFromTo === 1 ? 'Employee 1' : 'Employee 2',
                    cellStyle: {
                        borderLeft: '2px solid #CCCCCC'
                    },
                    headerStyle: {
                        borderLeft: '2px solid #CCCCCC'
                    },
                    render: rowData => {
                        let content = this.getEmployeeName(rowData, empFromTo)
                        let employee = this.getEmployee(rowData, empFromTo);
                        if (columns.length > 0 && employee !== undefined && dataviewsData[employee] !== undefined) {
                            let relevantDate = this.getRelevantDate(rowData, empFromTo);
                            let d = dataviewsData[employee][relevantDate]
                            if (!d) {
                                d = dataviewsData[employee]['ANY'];
                            }
                            if (d) {
                                content = <TooltipDataviewEmployee
                                    listCol={columns}
                                    data={d.attributes}
                                    employeeName={content}
                                />
                            }
                        }
                        return content;
                    }
                };
            case "DEFAULT__SHIFT":
                return {
                    title: managerSetting.type === 3 ? 'VTO' : 'Shift',
                    headerStyle: {
                        width: '1700px'
                    },
                    sorting: false,
                    render: rowData => {
                        return <React.Fragment>
                            {this.getEmployeeShift(rowData, empFromTo, classes)}
                        </React.Fragment>;
                    }
                };
            case "DEFAULT__AWARDING":
                return (managerSetting.adminSettings[0].awardingRuleEnabled ?
                    {
                        title: <div style={{ textAlign: 'center' }}>Award status</div>,
                        sorting: false,
                        render: rowData => {
                            const isGrey = (rowData.status.value === 3 && rowData.awardingResult);
                
                            return (
                                <React.Fragment>
                                    {rowData.awardingResult && (
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <FontAwesomeIcon
                                                icon={faThumbsUp}
                                                style={{ color: isGrey ? 'grey' : 'black' }}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        }
                    }
                    : null

                )
            case "DEFAULT__SENIORITY":
                return (managerSetting.adminSettings[0].awardingRuleEnabled ?
                    {
                        title: <div style={{ textAlign: 'center' }}>Seniority rank</div>,
                        sorting: false,
                        render: rowData => {
                            return <React.Fragment>
                                {rowData.awardingResultDetails && <div style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>{rowData.awardingResultDetails.value}</div>}
                            </React.Fragment>;
                        }
                    }
                    : null
                )
            default:
                break;
        }
    }

    getRequestDate(rowData) {
        switch (rowData.actionType) {
            case RequestTypes.toCover:
            case RequestTypes.openShift:
                return rowData.shift.startDateTime;
            case RequestTypes.shiftSwap:
                return rowData.startDate;
            case RequestTypes.voluntaryTimeOff:
                //rowData.startDate: "2023-11-03T00:00:00+00:00" -> Must remove the +00:00
                const startDateInLocalTz = new Date(rowData.startDate);
                const localOffset = startDateInLocalTz.getTimezoneOffset();
                const startDate = new Date(startDateInLocalTz.getTime() + localOffset * 60000);
                return startDate;
            default:
                break;
        }
    }

    generateDefaultRequestColumn(row, classes) {

        switch (row.DataviewKey) {
            case "DEFAULT__DATE":
                return {
                    title: 'Date submitted',
                    cellStyle: {
                        maxWidth: 20
                    },
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                return (
                                    <React.Fragment>
                                        {getAsLongDateTime(rowData.requestDate)}
                                    </React.Fragment>
                                );
                            case RequestTypes.shiftSwap:
                                return (
                                    <React.Fragment>
                                        {getAsLongDateTime(rowData.submissionDate)}
                                    </React.Fragment>
                                );
                            default:
                                break;
                        }
                    },
                    customSort: (a, b) => {
                        let dateA, dateB;
                        if (a.actionType === RequestTypes.shiftSwap) {
                            dateA = formatAs(a.submissionDate, DateFnsFormats.ISO);
                        }
                        else {
                            dateA = formatAs(a.requestDate, DateFnsFormats.ISO);
                        }

                        if (b.actionType === RequestTypes.shiftSwap) {
                            dateB = formatAs(b.submissionDate, DateFnsFormats.ISO);
                        } else {
                            dateB = formatAs(b.requestDate, DateFnsFormats.ISO);
                        }

                        return dateA < dateB ? -1 : 1
                    }
                }
            case "DEFAULT__DATE_REQUESTED":
                return {
                    title: 'Date requested',
                    cellStyle: {
                        maxWidth: 20
                    },
                    render: rowData => {
                        return (
                            <React.Fragment>
                                {getAsLongDate(this.getRequestDate(rowData))}
                            </React.Fragment>
                        )
                    },
                    customSort: (a, b) => {
                        const dateA = formatAs(this.getRequestDate(a), DateFnsFormats.ISO);
                        const dateB = formatAs(this.getRequestDate(b), DateFnsFormats.ISO);

                        return dateA < dateB ? -1 : 1
                    }
                }

            case "DEFAULT__REQUEST_TYPE":
                return {
                    title: 'Request type',
                    width: '5',
                    maxWidth: '5',
                    render: rowData => {
                        return (
                            <React.Fragment>
                                <RequestTypeChip request={rowData} classes={classes} />
                            </React.Fragment>
                        )
                    },
                    customSort: (a, b) => {
                        return a.requestType < b.requestType ? -1 : 1
                    }
                };
            case "DEFAULT__STATUS":
                return {
                    title: 'Status',
                    headerStyle: {
                        width: '100px'
                    },
                    sorting: false,
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                return (
                                    <div className="dataviewTable--status-cell">
                                        <Typography component={'h2'} >
                                            {rowData.status.label}
                                        </Typography>
                                        {
                                            (rowData.messages?.length)
                                                ? (
                                                    <AdditionalInfo
                                                        icon={<MessageIcon className="message-icon" />}
                                                        placement="auto"
                                                    >
                                                        {
                                                            rowData.messages.map(log => (
                                                                <div>
                                                                    <span className="text-lg-regular">
                                                                        {`${log.employeeName}: "${log.message}"`}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        }
                                                    </AdditionalInfo>
                                                )
                                                : <></>
                                        }
                                    </div>
                                )
                            default:
                                break;
                        }
                    }
                };
            case "DEFAULT__WARNING":
                return {
                    title: 'Warning',
                    field: 'warning',
                    sorting: false,
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                let warningMsgs;
                                if (rowData['warnings'].length) {
                                    warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                }
                                return (
                                    warningMsgs ?
                                        <React.Fragment>
                                            <WarnTooltip
                                                title={warningMsgs}>
                                                <Button className={classes.transparentButton}>
                                                    <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                </Button>
                                            </WarnTooltip>
                                        </React.Fragment>
                                        :
                                        null
                                )
                            default:
                                break;
                        }
                    }

                };
            case "DEFAULT__APPROVE_BY":
                return {
                    title: 'Modified by',
                    field: 'approvedByManagerName',
                    sorting: false,
                    render: rowData => {
                        return (
                            <React.Fragment>
                                <Typography>
                                    {GetModifiedBy(rowData.status.value, rowData.approvedByManagerName)}
                                </Typography>
                            </React.Fragment>
                        )
                    }
                };
            default:
                break;
        }
        return null;
    }


    renderTable() {
        let { classes, data, dataviewsData, requestColumns, employee1Columns, employee2Columns, managerSetting, activeSubmissionPeriodSettingsWithAwarding, signUpRequestSelected,
            isNonActiveSignUpRequestSelected, fetchResultData, onCheckedRequest } = this.props;
        let columns = this.generateColumns(managerSetting, requestColumns, employee1Columns, employee2Columns, dataviewsData, classes);

        return <MuiThemeProvider theme={this.theme} >
            <MaterialTable
                icons={tableIcons}
                title={"Dataview"}
                columns={columns}
                data={data}
                detailPanel={[
                    rowData => ({
                        disabled: !rowData.detailPanel,
                        icon: rowData => { return rowData.rowData.detailPanel ? <FontAwesomeIcon icon={faChevronDown} className={classes.plusMinus} /> : null },
                        iconProps: { rowData, classes },
                        openIcon: rowData => { return <FontAwesomeIcon icon={faChevronUp} className={classes.plusMinus} /> },
                        openIconProps: { classes },
                        render: rowData => {
                            switch (rowData.actionType) {
                                case RequestTypes.toCover:
                                    return (
                                        <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeFrom.name}</Typography>
                                            </Grid>
                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                <EmployeeCalendar schedule={this.generateSchedule(rowData, 'from')} shiftDate={rowData.shift.startDateTime} />
                                            </Grid>
                                            <Grid item xs={12} className={classes.divider}></Grid>
                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                            </Grid>
                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.shift.startDateTime} />
                                            </Grid>
                                        </Grid>
                                    )
                                case RequestTypes.shiftSwap:
                                    if (rowData.swapRequestShiftInfo.length <= 1) {
                                        return (
                                            <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                <Grid item xs={1} className={classes.detailPanelShift}>
                                                    <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.offerorEmployeeName}</Typography>
                                                </Grid>
                                                <Grid item xs={11} className={'manager-dashboard'}>
                                                    <EmployeeCalendar schedule={this.generateSchedule(rowData, 'from')} shiftDate={rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails.startDateTime} />
                                                </Grid>
                                                <Grid item xs={12} className={classes.divider}></Grid>
                                                <Grid item xs={1} className={classes.detailPanelShift}>
                                                    <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.swapProposal.proposalEmployeeName}</Typography>
                                                </Grid>
                                                <Grid item xs={11} className={'manager-dashboard'}>
                                                    <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.swapProposalShiftInfo[0].shiftInfo.shiftDetails.startDateTime} />
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    else if (rowData.swapRequestShiftInfo.length > 1) {
                                        return (
                                            <React.Fragment>
                                                <Grid container style={{ backgroundColor: '#e4eaf0' }}  >
                                                    <Grid items xs={12} style={{ padding: 5 }} >
                                                        <MaterialTable
                                                            icons={tableIcons}
                                                            title={rowData.offerorEmployeeName}
                                                            columns={[
                                                                {
                                                                    title: 'Shift Start Date',
                                                                    cellStyle: {
                                                                        maxWidth: 20
                                                                    },
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                            </React.Fragment>
                                                                        )
                                                                    },
                                                                },
                                                                {
                                                                    title: 'Shift',
                                                                    field: 'shiftName',
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                <ShiftCardWithTooltip
                                                                                    shift={rowData.shiftInfo.shiftDetails}
                                                                                    actionType={rowData.actionType}
                                                                                    isLargeShiftTimeText
                                                                                />
                                                                            </React.Fragment>
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    title: 'Location',
                                                                    field: 'location',
                                                                    render: rowData => {
                                                                        const firstValidSegment = rowData.shiftInfo.shiftDetails.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT)
                                                                        return (
                                                                            <React.Fragment>
                                                                                <Typography className={classes.employeeNameText}>
                                                                                    {`${firstValidSegment && firstValidSegment.orgJobRef.qualifier}`}
                                                                                </Typography>
                                                                            </React.Fragment>
                                                                        )
                                                                    }

                                                                },
                                                                {
                                                                    title: 'Warning',
                                                                    field: 'warning',
                                                                    headerStyle: {
                                                                        textAlign: 'center'
                                                                    },
                                                                    render: rowData => {
                                                                        let warningMsgs;
                                                                        if (rowData['warnings'].length) {
                                                                            warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                                                        }

                                                                        return (
                                                                            warningMsgs ?
                                                                                <React.Fragment>
                                                                                    <WarnTooltip
                                                                                        title={warningMsgs}>
                                                                                        <Button className={classes.transparentButton}>
                                                                                            <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                        </Button>
                                                                                    </WarnTooltip>
                                                                                </React.Fragment>
                                                                                :
                                                                                null
                                                                        )
                                                                    }

                                                                }
                                                            ]}
                                                            data={rowData.swapRequestShiftInfo}
                                                            options={{
                                                                paging: false,
                                                                draggable: false,
                                                                maxBodyHeight: '65vh',
                                                                headerStyle: {
                                                                    fontWeight: 900,
                                                                    fontSize: '14px',
                                                                    textDecoration: 'underline',
                                                                },
                                                                detailPanelType: 'single',
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid items xs={12} style={{ padding: 5 }} >
                                                        <MaterialTable
                                                            icons={tableIcons}
                                                            title={rowData.swapProposal.proposalEmployeeName}
                                                            columns={[
                                                                {
                                                                    title: 'Shift Start Date',
                                                                    cellStyle: {
                                                                        maxWidth: 20
                                                                    },
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                            </React.Fragment>
                                                                        )
                                                                    },
                                                                },
                                                                {
                                                                    title: 'Shift',
                                                                    field: 'shiftName',
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                <ShiftCardWithTooltip
                                                                                    shift={rowData.shiftInfo.shiftDetails}
                                                                                    actionType={rowData.actionType}
                                                                                    isLargeShiftTimeText
                                                                                />
                                                                            </React.Fragment>
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    title: 'Location',
                                                                    field: 'location',
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                <Typography className={classes.employeeNameText}>
                                                                                    {`${rowData.shiftInfo.shiftDetails.segments[0].orgJobRef.qualifier}`}
                                                                                </Typography>
                                                                            </React.Fragment>
                                                                        )
                                                                    }

                                                                },
                                                                {
                                                                    title: 'Warning',
                                                                    headerStyle: {
                                                                        textAlign: 'center'
                                                                    },
                                                                    field: 'warning',
                                                                    render: rowData => {
                                                                        let warningMsgs;
                                                                        if (rowData['warnings'].length) {
                                                                            warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                                                        }

                                                                        return (
                                                                            warningMsgs ?
                                                                                <React.Fragment>
                                                                                    <WarnTooltip
                                                                                        title={warningMsgs}>
                                                                                        <Button className={classes.transparentButton}>
                                                                                            <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                        </Button>
                                                                                    </WarnTooltip>
                                                                                </React.Fragment>
                                                                                :
                                                                                null
                                                                        )
                                                                    }

                                                                }
                                                            ]}
                                                            data={rowData.swapProposalShiftInfo}
                                                            options={{
                                                                paging: false,
                                                                draggable: false,
                                                                maxBodyHeight: '65vh',
                                                                headerStyle: {
                                                                    fontWeight: 900,
                                                                    fontSize: '14px',
                                                                    textDecoration: 'underline',
                                                                },
                                                                detailPanelType: 'single',
                                                            }}

                                                        />
                                                    </Grid>
                                                </Grid>
                                            </React.Fragment>
                                        )
                                    }
                                    break;
                                case RequestTypes.openShift:
                                    return (
                                        <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                            </Grid>
                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.shift.startDateTime} />
                                            </Grid>
                                        </Grid>
                                    )
                                case RequestTypes.voluntaryTimeOff:
                                    let schedules = this.generateSchedule(rowData, 'to')
                                    let eeScheduleStartDates = schedules.map(d => moment(d.start))
                                    let eeScheduleEndDates = schedules.map(d => moment(d.end))
                                    let startOfWeekDate = moment.min(eeScheduleStartDates).clone().day(0)//this sunday
                                    let endOfWeekDate = moment.max(eeScheduleEndDates).clone().day(6) //this saturday
                                    let weeksCount = Math.ceil(endOfWeekDate.diff(startOfWeekDate, 'weeks', true))
                                    //find first affected shift
                                    let parsedShifts = rowData.shifts.map(x => moment(x.shiftInfo.startDateLocationTime))
                                    let firstAffectedShift = moment.min(parsedShifts)
                                    if (weeksCount <= 6) {
                                        return (
                                            <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                <Grid item xs={12} className={classes.detailPanelShift}>
                                                    <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{startOfWeekDate.format(MomentFormats.VERBOSE_LONG_DATE_WITH_DAY)} to {endOfWeekDate.format(MomentFormats.VERBOSE_LONG_DATE_WITH_DAY)} </Typography>
                                                </Grid>
                                                <Grid item xs={1} className={classes.detailPanelShift}>
                                                    <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                                </Grid>
                                                <Grid item xs={11} className={'manager-dashboard'}>

                                                    <EmployeeCalendar
                                                        schedule={schedules}
                                                        shiftDate={firstAffectedShift}
                                                        weeksCount={weeksCount} />
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    else {
                                        return (
                                            <React.Fragment>
                                                <Grid container style={{ backgroundColor: '#e4eaf0' }}  >
                                                    <Grid items xs={12} style={{ padding: 5 }} >
                                                        <MaterialTable
                                                            icons={tableIcons}
                                                            title={''}
                                                            columns={[
                                                                {
                                                                    title: 'Shift Start Date',
                                                                    cellStyle: {
                                                                        maxWidth: 20
                                                                    },
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                            </React.Fragment>
                                                                        )
                                                                    },
                                                                },
                                                                {
                                                                    title: 'Shift Name',
                                                                    field: 'shiftName',
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                <ShiftCardWithTooltip
                                                                                    shift={rowData.shiftInfo.shiftDetails}
                                                                                    actionType={RequestTypes.voluntaryTimeOff}
                                                                                    isLargeShiftTimeText
                                                                                />
                                                                            </React.Fragment>
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    title: 'Location',
                                                                    field: 'location',
                                                                    render: rowData => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                <Typography className={classes.employeeNameText}>
                                                                                    {`${rowData.shiftInfo.shiftDetails.segments[0].orgJobRef.qualifier}`}
                                                                                </Typography>
                                                                            </React.Fragment>
                                                                        )
                                                                    }

                                                                },
                                                            ]}
                                                            data={_.sortBy(rowData.shifts, ['shiftInfo.startDateLocationTime'])}
                                                            options={{
                                                                search: false,
                                                                paging: false,
                                                                draggable: false,
                                                                maxBodyHeight: '40vh',
                                                                headerStyle: {
                                                                    fontWeight: 900,
                                                                    fontSize: '14px',
                                                                    textDecoration: 'underline',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                            </React.Fragment>
                                        )
                                    }
                                default:
                                    break;
                            }

                        }
                    })
                ]}
                options={{
                    search: false,
                    paging: false,
                    draggable: false,
                    maxBodyHeight: '65vh',
                    headerStyle: {
                        fontWeight: 900,
                        fontSize: '14px',
                        textDecoration: 'underline',
                    },
                    detailPanelType: 'single',
                    selection: true,
                    selectionProps: (rowData) => {
                        const isDisabled = [RequestStatus.RetractedSubmitted, RequestStatus.Approved, RequestStatus.Refused].includes(rowData.status.value) ||
                            //signUp is already selected && rowData is not a sign up with active submission period
                            (signUpRequestSelected && !activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId)) ||
                            //selected is not signup && rowData is a sign up with active submission period
                            (isNonActiveSignUpRequestSelected && activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId))
                        rowData.tableData.disabled = isDisabled;

                        return {
                            disabled: isDisabled
                        }
                    },
                    sorting: true,
                    /* You can not use fixed columns feature with detail panels, treedata or grouping for now. (https://material-table.com/#/docs/features/fixed-columns)
                    fixedColumns: {
                        left: requestColumns.filter(c => c.Active).length
                    }
                    */
                }}
                onSelectionChange={onCheckedRequest}
                components={{
                    Toolbar: props => (
                        <div>
                            <Grid container >
                                <Grid item xs={3} md={3} lg={2}>
                                    <MTableToolbar {...props} />
                                </Grid>
                                <Grid item xs={8} md={8} lg={9} style={{ display: "flex", alignItems: "center" }}>
                                    {props.renderData[0]?.actionType === RequestTypes.voluntaryTimeOff && (
                                        <SubmissionPeriodLabel request={props.renderData[0]} classes={classes} />)
                                    }
                                </Grid>
                                <Grid item xs={1} md={1} lg={1} style={{ textAlign: "right", padding: "7px" }} >
                                    <ReactSelect
                                        value={this.props.selectedFetchSize}
                                        options={this.props.fetchSizeOptions}
                                        onChange={this.handleSelectFetchSize}
                                        customStyles={{
                                            control: styles => ({
                                                ...styles,
                                                margin: '5px 5px 5px 5px',
                                                border: '1px solid #CCCCCC',
                                                padding: 3,
                                                height: 25,
                                                minWidth: 91
                                            }),
                                            menu: styles => ({
                                                ...styles,
                                                zIndex: 100
                                            })
                                        }}
                                        selectWrapperClass={classes.selectWrapper}
                                    />
                                </Grid>
                            </Grid>

                        </div>
                    ),
                    Body: (props) => {
                        if (props.renderData.length > 0) {
                            return (
                                <React.Fragment>
                                    <MTableBody {...props} />

                                    <tr>
                                        <td style={{ textAlign: 'center' }} colspan="12">
                                            <div>
                                                <Typography className={classes.labelViews}>You've viewed {fetchResultData.viewed} of {fetchResultData.total} requests</Typography>
                                            </div>
                                            <div>
                                                <Button mt={1} hidden={this.props.addMoreDisable} className={classes.buttonAddMore} onClick={() => this.props.addMoreRequests()}>
                                                    <Typography className={classes.labelButtons}>Load more requests</Typography>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>


                                </React.Fragment>
                            )
                        }
                        else {
                            return (
                                <React.Fragment>
                                    <MTableBody {...props} />
                                </React.Fragment>
                            )
                        }
                    }
                }}
            />
        </MuiThemeProvider>;
    }

    toggleCollapsable() {
        this.setState({
            opened: 1 - this.state.opened
        });
    }

    render() {

        let { t, classes, OpenShiftKeyTable, managerSetting, data } = this.props;

        const displaySegmentInfos = (segments) => segments.map(x => <span className={'segment-infos'}><span className={'segment-info-time'}>{`${getAsStartAndEndTimeFormat(x.startDateTime, x.endDateTime)} ${displayDurationInHours(x)}`} {x.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? <CompareArrowsIcon className="segment-info-transfer" /> : ""}</span> {t(`SegmentType.${x.type}`)}</span>);

        let { opened } = this.state;

        const tableComponent = <React.Fragment>
            {this.renderTable()}
        </React.Fragment>;
        let tableWithCollapsable = tableComponent;
        const firstData = data[0];
        if (OpenShiftKeyTable) {
            const isOpenShiftSignUp = firstData.requestSubtype === RequestSubtypes.signUp;

            tableWithCollapsable = <MuiThemeProvider theme={this.theme} >
                <div className={classes.dataviewTableGroup}>
                    <div className={classes.dataviewTableGroupHeader} >
                        <FontAwesomeIcon className={classes.dataviewTableToggleButton} icon={opened ? faAngleUp : faAngleDown} size={"2x"} onClick={() => { this.toggleCollapsable() }} />
                        <div className={classes.dataviewTableGroupHeaderShift} >
                            <Typography className={classes.shiftTimeTextLarge} style={{ whiteSpace: 'nowrap' }}>
                                {getAsStartAndEndTimeFormat(firstData.shift.startDateTime, firstData.shift.endDateTime)}
                                {hasTransfer(firstData.shift) ? ' (X) ' : ' '}
                                {`(${getAsLongDate(firstData.shift.startDateTime)})`}
                            </Typography>
                        </div>
                        {
                            data.every(x => x.completed)
                                ?
                                <CustomToolTip
                                    titleText={"Open shift bid completed"}
                                    jsx={
                                        <div className={classes.dataviewTableGroupHeaderShift} style={{ margin: 16, marginBottom: 0 }}>
                                            <FontAwesomeIcon icon={faCalendarCheck} />
                                        </div>
                                    }
                                />
                                :
                                <div className={classes.dataviewTableGroupHeaderShift} style={{ margin: 20 }} />
                        }
                        {
                            isOpenShiftSignUp
                                ? (
                                    <>
                                        <div className={classes.dataviewTableGroupHeaderShift} >
                                            <SubmissionPeriodLabel classes={classes} request={firstData} />
                                        </div>
                                        <div className={classes.dataviewTableRecalculateAwarding} >
                                            <CustomToolTip
                                                titleText={"Run awarding rules"}
                                                jsx={
                                                    <Button disabled={!managerSetting.adminSettings[0].awardingRuleEnabled} onClick={() => this.props.handleRecalculateAwarding('OS', firstData.openShiftKey)} className={classes.moreOptionsButton} aria-label="more">
                                                        <FontAwesomeIcon className={classes.iconFixHeight} icon={faSyncAlt} />
                                                    </Button>
                                                }
                                            />
                                        </div>
                                    </>)
                                :
                                null
                        }
                    </div>
                    <div className={classes.dataviewTableSegmentInfos}>
                        {displaySegmentInfos(firstData.shift.segments)}
                    </div>
                    <Collapse
                        in={opened}
                        timeout={{ enter: 750, exit: 750 }}
                        style={{ transitionDelay: "250ms" }}
                    >

                        {tableComponent}
                    </Collapse>
                </div>
            </MuiThemeProvider >
        }

        return <React.Fragment>{tableWithCollapsable}</React.Fragment>;
    }
}

const mapStateToProps = state => {
    return {
        requestColumns: state.dataviewRequestColumns,
        employee1Columns: state.dataviewEmployee1Columns,
        employee2Columns: state.dataviewEmployee2Columns,
        dataviewsData: state.dataviewsData,
        selectedFetchSize: state.selectedFetchSize,
        fetchSizeOptions: state.fetchSizeOptions,
        managerSettingsList: state.managerSettingsList,
    }
}
const mapDispatchToProps = {
    updateFetchSizeOption
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withStyles(ManagerTableViewStyles)(DataviewTable)));